import { DemandGenTabsDef, DisplayTabsDef } from '../../../utils/TabsDef';
import { useGoogleAssetsTextsStore } from 'stores/GoogleAssets/GoogleAssetsTextsStore';
import { useGoogleAssetsImagesStore } from 'stores/GoogleAssets/GoogleAssetsImagesStore';
import { useGoogleAssetsBuilderStore } from 'stores/GoogleAssets/GoogleAssetsBuilderStore';
import { GoogleAssetsEntities } from '../../../constants';
import { CampaignsGoogleConfigsCampaignTypeEnum } from '../../../../../../../../../api';

export const useTabs = () => {
  const { images } = useGoogleAssetsImagesStore();
  const { tabAssets } = useGoogleAssetsTextsStore();
  const { activeTab, setActiveTab, article } = useGoogleAssetsBuilderStore();

  const activeTabKey = activeTab.key;

  const handleTabChange = (tabKey: string) => {
    const existTab = tabsDef.find(({ key }) => key === tabKey);

    if (!existTab) throw new Error('Incorrect Tab');

    setActiveTab(existTab);
  };

  const tabsDef =
    article?.campaign.campaignsGoogleConfig?.campaignType === CampaignsGoogleConfigsCampaignTypeEnum.demand_gen
      ? DemandGenTabsDef
      : DisplayTabsDef;

  const selections = {
    [GoogleAssetsEntities.IMAGES]: images.length,
    [GoogleAssetsEntities.Headlines]: tabAssets[GoogleAssetsEntities.Headlines].filter((i) => i.text).length,
    [GoogleAssetsEntities.Descriptions]: tabAssets[GoogleAssetsEntities.Descriptions].filter((i) => i.text).length,
    [GoogleAssetsEntities.ShortHeadlines]: tabAssets[GoogleAssetsEntities.ShortHeadlines].filter((i) => i.text).length,
    [GoogleAssetsEntities.LongHeadlines]: tabAssets[GoogleAssetsEntities.LongHeadlines].filter((i) => i.text).length
  };

  return { activeTab, tabsDef, activeTabKey, handleTabChange, selections };
};
